import './NewInvitesList.scss';
import { NewInvite } from 'types/organization/invites';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { IconButton } from '@trackman/web-shared-components';

type Props = {
  newInvitesList: NewInvite[];
  deleteNewInvite: (email: string, index: number) => void;
};

export const NewInvitesList = ({ newInvitesList, deleteNewInvite }: Props) => {
  return (
    <ul className='new-invites-list'>
      {newInvitesList.map((invite, index) => (
        <li key={`invite-${index}`} className='invite-item'>
          <div className='invite-data'>
            <div className='ordinal-number'>{index + 1}</div>
            <div className='name'>
              <strong>{invite.name}</strong>
            </div>
            <div className='email'>
              <span>{invite.email}</span>
            </div>
          </div>
          <IconButton icon={() => <TrashIcon />} onClick={() => deleteNewInvite(invite.email, index)} />
        </li>
      ))}
    </ul>
  );
};
